import React, { useState } from 'react';
import { TrendingUp } from 'lucide-react';
import DateRangePicker from '../components/Analytics/DateRangePicker';
import YoYComparison from '../components/Analytics/YoYComparison';
import ServiceProfitability from '../components/Analytics/ServiceProfitability';
import WinLossAnalysis from '../components/Analytics/WinLossAnalysis';

/**
 * Advanced Analytics Page
 * Year-over-year comparison, service profitability, win/loss analysis
 */
export default function AdvancedAnalytics() {
  const [dateRange, setDateRange] = useState({ preset: 'last30days' });
  const [yoyPeriod, setYoyPeriod] = useState('monthly');

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-lg">
            <TrendingUp className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Advanced Analytics</h1>
            <p className="text-sm text-slate-500">Deep insights and performance trends</p>
          </div>
        </div>
        
        {/* Date Range Picker */}
        <DateRangePicker value={dateRange} onChange={setDateRange} />
      </div>

      {/* YoY Period Selector */}
      <div className="flex gap-2 mb-6">
        <button
          onClick={() => setYoyPeriod('monthly')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            yoyPeriod === 'monthly'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
          }`}
        >
          Monthly Comparison
        </button>
        <button
          onClick={() => setYoyPeriod('quarterly')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            yoyPeriod === 'quarterly'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
          }`}
        >
          Quarterly Comparison
        </button>
        <button
          onClick={() => setYoyPeriod('annual')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            yoyPeriod === 'annual'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
          }`}
        >
          Annual Comparison
        </button>
      </div>

      <div className="space-y-6">
        {/* Year-over-Year Comparison */}
        <YoYComparison period={yoyPeriod} />
        
        {/* Service Profitability */}
        <ServiceProfitability dateRange={dateRange} />
        
        {/* Win/Loss Analysis */}
        <WinLossAnalysis dateRange={dateRange} />
      </div>
    </div>
  );
}
